import { FileCheck2 } from "lucide-react";
import LegalPageLayout from "../components/LegalPageLayout";

const sections = [
  {
    id: "acceptance",
    title: "1. Acceptance of terms",
    body: [
      "These Terms of Service govern access to and use of the EXOPILOT cloud console, the on-premise local server software, and the companion phone application (together, the \"Service\"). By creating a workspace or using the Service, your organisation (\"Customer\") agrees to these terms.",
    ],
  },
  {
    id: "the-service",
    title: "2. The service",
    body: [
      "EXOPILOT is a service-quality intelligence platform: pendant devices capture customer interactions, an on-premise server operated by Customer scores those interactions against Customer's own SOPs, and numeric scores sync to a cloud console for reporting. Customer is solely responsible for operating the local server and the recordings it processes.",
    ],
  },
  {
    id: "accounts",
    title: "3. Accounts & workspaces",
    body: [
      "Each workspace is tied to one organisation. Customer is responsible for the accuracy of information provided, for maintaining the confidentiality of administrator credentials, and for all activity under its workspace. Notify us immediately of any suspected unauthorised access.",
    ],
  },
  {
    id: "acceptable-use",
    title: "4. Acceptable use",
    body: [
      "Customer will use the Service only for lawful workplace quality coaching, will inform employees that interactions are recorded and evaluated, and will obtain any consent required by local employment and privacy law. Customer will not use the Service to covertly surveil employees outside its stated purpose, to process data it does not have the right to process, or to attempt to circumvent the architecture that keeps audio on-premise.",
    ],
  },
  {
    id: "data-ownership",
    title: "5. Data ownership",
    body: [
      "Customer owns all data it inputs into the Service — employee records, SOPs, audio recordings, and resulting scores. We claim no ownership over Customer data and will not use it to train models or for any purpose outside operating the Service.",
    ],
  },
  {
    id: "availability",
    title: "6. Availability & the local server",
    body: [
      "The cloud console depends on network connectivity between Customer's local server and our infrastructure for syncing scores and SOPs. Scoring itself runs entirely offline on Customer's local server and is unaffected by cloud connectivity. We do not guarantee any specific uptime for the cloud console absent a separate written SLA.",
    ],
  },
  {
    id: "fees",
    title: "7. Fees",
    body: [
      "Fees, billing cycles, and payment terms are as set out in Customer's order form or subscription agreement. Unpaid invoices past their due date may result in suspension of console access after notice.",
    ],
  },
  {
    id: "termination",
    title: "8. Termination",
    body: [
      "Either party may terminate for convenience per the notice period in the order form, or immediately for material breach that remains uncured after 30 days' notice. On termination, Customer may request export of its data; cloud data is deleted per the retention terms in our Privacy Policy.",
    ],
  },
  {
    id: "warranties",
    title: "9. Warranties & liability",
    body: [
      "The Service is provided on an \"as is\" basis except as expressly warranted in a signed order form. To the maximum extent permitted by law, neither party is liable for indirect, incidental, or consequential damages, and each party's aggregate liability is capped as set out in the applicable order form.",
    ],
  },
  {
    id: "changes",
    title: "10. Changes to these terms",
    body: [
      "We will notify workspace administrators by email and console notice at least 30 days before material changes to these terms take effect. Continued use of the Service after that period constitutes acceptance.",
    ],
  },
  {
    id: "governing-law",
    title: "11. Governing law",
    body: [
      "These terms are governed by the laws specified in Customer's order form; absent one, by the laws of the jurisdiction in which EXOPILOT is incorporated, without regard to conflict-of-law principles.",
    ],
  },
  {
    id: "contact",
    title: "12. Contact",
    body: [
      "Questions about these terms: legal@exopilot.io",
    ],
  },
];

export default function Terms() {
  return (
    <LegalPageLayout
      testId="terms"
      eyebrowIcon={FileCheck2}
      eyebrow="Terms of Service"
      title="The rules of the road,"
      accent="written to be read."
      updated="June 2026"
      sections={sections}
      contactLine="Questions about these terms?"
      contactEmail="legal@exopilot.io"
    />
  );
}
